export const sumWithDecimals = (a: number, b: number): number | string => {
  const sum = a + b;
  return sum % 1 === 0 ? sum : sum.toFixed(2);
};

export const multiplyWithDecimals = (a: number, b: number): string | number => {
  const result = a * b;
  return result % 1 === 0 ? result : result.toFixed(2);
};

export const subractionWithDecimals = (a: number, b: number) => {
  const result = a - b;
  return result % 1 === 0 ? result : result.toFixed(2);
};

export const withDecimalsIfNeeded = (amount: number): string => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const toFixedWithoutRounding = (
  val: number,
  decimals: number
): number => {
  const multiplier = Math.pow(10, decimals);
  return Math.floor(val * multiplier) / multiplier;
};
